import { render, staticRenderFns } from "./CalendarBox.vue?vue&type=template&id=49e1a6b4&scoped=true&"
import script from "./CalendarBox.vue?vue&type=script&lang=js&"
export * from "./CalendarBox.vue?vue&type=script&lang=js&"
import style0 from "./CalendarBox.vue?vue&type=style&index=0&id=49e1a6b4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49e1a6b4",
  null
  
)

export default component.exports